const mutations = {
	setOrganization(state, data) {
		state.organization = data;
	},
};

export default mutations;